import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfilPrestataire } from "../../redux/actions/profilActions";

export default function ModalFormAddRealisationPresta({onUpdate, onClose }) {

    const [realisationForm, setRealisationForm] = useState({
        titre: "",
        description: "",
    });

    const dispatch = useDispatch();
    const { token } = useSelector((state) => state.auth);
    const apiUrl = process.env.REACT_APP_API_URL;

    const [selectedImages, setSelectedImages] = useState([]);
    const dropZoneImages = useRef();

    const preventDefaults = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDropFiles = (files, type) => {
        if (type === "images") {
            const newImgs = Array.from(files).map(f => ({
                file: f,
                url: URL.createObjectURL(f)
            }));
            setSelectedImages(prev => [...prev, ...newImgs]);
        }
    };

    const handleRemoveFile = (idx) => {
        setSelectedImages(prev => prev.filter((_, i) => i !== idx));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRealisationForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!realisationForm.titre || !realisationForm.description) {
            alert("Titre et description requis !");
            return;
        }

        try {
            const form = new FormData();

            form.append("titreRealisation", realisationForm.titre);
            form.append("descriptionRealisation", realisationForm.description);
            selectedImages.forEach((img) => form.append("photos[]", img.file));

            const response = await fetch(`${apiUrl}/api/updateProfil/addRealisationPrestataire`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: form,
            });

            const data = await response.json();

            if (!response.ok) {
                alert(data.message || "Erreur lors de l’ajout de la réalisation");
                return;
            }

            console.log("Réalisation ajoutée :", data);
        } catch (err) {
            console.error("Erreur envoi réalisation :", err);
            alert("Impossible de contacter le serveur.");
        }

        setRealisationForm({ titre: "", description: "" });
        onUpdate();
        onClose(); // ← gardé UNE SEULE fois
    };

    return (
        <div className="inscriptionModalOverlay">
            <div className="inscriptionModal">

                <button className="inscriptionModalClose" onClick={onClose}>×</button>

                <h2 className="step-title">Ajouter une Réalisation</h2>

                <form onSubmit={(e) => e.preventDefault()}>

                    {/* Titre */}
                    <div className="inscriptionPrestataireModal-input-form">
                        <label htmlFor="titre">Titre de la réalisation :</label>
                        <input
                            type="text"
                            id="titre"
                            name="titre"
                            value={realisationForm.titre}
                            onChange={handleChange}
                            placeholder="Nom"
                            className="form-input"
                        />
                    </div>

                    {/* Description */}
                    <div className="inscriptionPrestataireModal-input-form">
                        <label htmlFor="description">Description :</label>
                        <textarea
                            id="description"
                            name="description"
                            value={realisationForm.description}
                            onChange={handleChange}
                            placeholder="Décrivez la réalisation"
                        />
                    </div>

                    {/* Photos */}
                    <div className="modal-input-form"
                        ref={dropZoneImages}
                        onDragEnter={preventDefaults}
                        onDragOver={preventDefaults}
                        onDrop={(e) => {
                            preventDefaults(e);
                            handleDropFiles(e.dataTransfer.files, "images");
                        }}>
                        <label className="btn-label-add-files">
                            Ajouter des photos
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={(e) => handleDropFiles(e.target.files, "images")}
                                style={{ display: "none" }}
                            />
                        </label>

                        <div className="image-previews">
                            {selectedImages.map((img, idx) => (
                                <div key={idx} className="file-preview">
                                    <img src={img.url} alt="preview" />
                                    <button type="button" onClick={() => handleRemoveFile(idx)}>×</button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Bouton */}
                    <div className="inscriptionPrestataireModal-input-form">
                        <button
                            type="button"
                            onClick={handleSubmit}
                            disabled={!realisationForm.titre || !realisationForm.description}
                        >
                            Ajouter cette réalisation
                        </button>
                    </div>

                    <div className="inscriptionClientModal-actions">
                        <button type="button" onClick={onClose}>Annuler</button>
                    </div>

                </form>
            </div>
        </div>
    );
}
